
import { Select, Option } from "element-ui"
import _ from "lodash"
import { getStoreRegions, getClickCollectStores } from "@/api/delivery"
import { getComm } from "@/api/comm"
import { getDeliveryMethod, getRequestHeaders } from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      allOptions: [],
      region: "",
      regionOptions: [],
      district: "",
      disctrictOptions: [],
      storeList: [],
      activeItem: {},
      oldActiveItem: {}
    }
  },
  computed: {
    btnDisabled() {
      const { id } = this.activeItem
      const { id: compareId } = this.oldActiveItem

      if (getDeliveryMethod() === "homeDelivery" && id) {
        return false
      }
      if (!id) {
        return true
      }
      if (id && compareId && id === compareId) {
        return true
      }
      return false
    }
  },
  watch: {
    visible: {
      async handler(val) {
        if (val) {
          try {
            this.loading = true
            this.activeItem = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
            this.oldActiveItem = _.cloneDeep(this.activeItem)
            this.allOptions = []
            this.region = ""
            this.regionOptions = []
            this.district = ""
            this.disctrictOptions = []
            this.storeList = []
            await this.getRegionOptions()
            await this.getStores()
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    async getRegionOptions() {
      try {
        const { data: res } = await getStoreRegions()
        this.allOptions = res || []
        this.regionOptions = _.uniqBy(this.allOptions, "municipal")
        console.log("this.regionOptions===>", this.regionOptions)
      } catch (error) {
        console.log(error)
      }
    },
    handleRegionChange(value) {
      console.log("handleRegionChange", value)
      this.district = ""
      this.disctrictOptions = this.allOptions.filter(item => item.municipal === value)
      this.getStores()
    },
    handleDisctrictChange(value) {
      console.log("handleDisctrictChange", value)
      this.getStores()
    },
    async getStores() {
      try {
        this.loading = true
        const params = {}
        if (this.region) params.municipal = this.region
        if (this.district) params.district = this.district
        const { data: res } = await getClickCollectStores({ param: JSON.stringify(params) })
        this.storeList = res || []

        // 只有一个有效门店时默认选中
        const validStores = this.storeList.filter(item => !this.isDisabled(item))
        if (validStores && validStores.length === 1) {
          this.activeItem = (validStores && validStores[0]) || {}
        }

        this.setScrollTop()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    setScrollTop() {
      if (this.$refs.areaListWrapper) {
        this.$refs.areaListWrapper.scrollTop = 0
      }
    },
    isDisabled(item) {
      const availableCapacity = item.availableCapacity || 0
      return availableCapacity <= 0
    },
    isActive(item) {
      return this.activeItem.id && item.id && this.activeItem.id === item.id
    },
    toggleSelect(item) {
      if (this.isDisabled(item)) return
      console.log("toggleSelect", item)
      this.activeItem = item
    },
    handleClose() {
      this.$emit("close")
    },
    async handleSave() {
      try {
        if (this.btnDisabled) return
        console.log("save", this.activeItem)
        const { erpStoreId, supplierErpStoreId, lat, lng } = this.activeItem
        const params = {
          shipmentType: 2,
          pickUpStoreId: erpStoreId,
          supplierErpStoreId,
          latitude: lat,
          longitude: lng
        }
        await getComm({ param: JSON.stringify(params) })

        this.activeItem._locale = getLanguage()
        localStorage.setItem("curSelStore", JSON.stringify(this.activeItem))

        this.handleClose()
        setTimeout(() => {
          window.location.reload()
        }, 200)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
